//Archivo que sirve como �ndice a los archivos del m�dulo.
//Si se necesita cambiar la ubicaci�n del alg�n archivo, cambiando aca a donde apunta.

//Configuraciones
export { PaginadorConfig } from "./Configuraciones/paginador.config";

//Directivas
export { PermisoDirective } from "./Directivas/permiso.directive";

//Enumeradores
export { TipoUrlEnum } from "./Enumerables/tipo-url.enum";
export { TipoPopUpEnum } from "./Enumerables/tipo-pop-up.enum";

//Guards
export { PermisoGuard } from "./Guards/permiso.guard";